import Box from "@material-ui/core/Box";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { fetchBasket } from "../../services/basket/actions";
import { loginAPI } from "../../services/login/actions";
import BusinessCatalogus from "./BusinessCatalogus";
import "./Catalogus.scss";
import PublicCatalogus from "./PublicCatalogus";

function CatalogusWrapper(props) {
  useEffect(() => {
    props.fetchBasket(props.currentLocation.id, props.userId);
    // eslint-disable-next-line
  }, [props.currentLocation, props.userId]);

  const { data, columnsMapping, publicAssortiment } = props;

  if (!data.length) {
    return <p align="center">Geen producten om weer te geven...</p>;
  }
  if (data && columnsMapping) {
    if (publicAssortiment) {
      return (
        <PublicCatalogus data={data} loginSuccesful={props.loginSuccesful} />
      );
    } else {
      return (
        <BusinessCatalogus data={data} loginSuccesful={props.loginSuccesful} />
      );
    }
  } else {
    return (
      <Box p={1}>
        <h1>Geen producten</h1>
      </Box>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentLocation: state.currentInformation.current_location,
    userId: state.login.data.user_id,
    basketProducts: state.basket.products,
    loginSuccesful: state.login.data.loginSuccesful,
  };
}

export default connect(mapStateToProps, {
  loginAPI,
  fetchBasket,
})(CatalogusWrapper);
